// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import GeoAutocompleteNext from '@ott/geo-autocomplete-next';

function Autocomplete(field) {
  const { input, type, triggerProps, ...rest } = field;

  return (
    <GeoAutocompleteNext
      triggerProps={{
        ...input,
        ...triggerProps,
        type,
      }}
      revertChanges={true}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
}

export default Autocomplete;
